import {
  createStyles,
  makeStyles,
} from '@mui/styles';
import { Theme, } from '@mui/material';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      display: 'flex',
      flexWrap: 'wrap',
    },
    input: {
      display: 'none',
    },
    inline: {
      margin: theme.spacing(1),
    },
    img: {
      width: '15%',
      marginBottom: '1rem',
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    paddingBox: {
      paddingBottom: '15px',
    },
    button: {
      margin: theme.spacing(1),
    },
    margin: {
      margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      width: '25ch',
    },
  })
);

export default useStyles;
